import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, switchMap } from 'rxjs';
import { LocaleTokenValueEntityService } from '../../state/entity-services/locale-token-value-entity.service';
import { map } from 'rxjs/operators';
import { FeatureFlagService } from '../services/feature-flag.service';

@Injectable()
export class LocaleTokenGuard implements CanActivate {
  constructor(
    private featureFlagService: FeatureFlagService,
    private localeTokenValueEntityService: LocaleTokenValueEntityService,
    private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.featureFlagService.getFeatureFlagSearchesByOrgId().pipe(
      switchMap(() => {
        return this.localeTokenValueEntityService.localeTokenSearch({
          locale: this.localeTokenValueEntityService.getLocale(),
          scope: 'patient',
          enabledFeatureFlagNames: this.featureFlagService.getFeatureFlagsEnabled()
        }).pipe(
          map(() => {
            return true;
          })
        );
      })
    );
  }
}
